import ClientOAuth2 from "client-oauth2";
import Config from "./Config";

export default class OauthClientFactory {

    static create() {
        return new ClientOAuth2({
            clientId: Config.tnAccountClientId,
            clientSecret: Config.tnAccountClientSecret,
            accessTokenUri: `${Config.tnAccountDomain}/api/token`,
            authorizationUri: `${Config.tnAccountDomain}/api/auth`,
            redirectUri: `${Config.domain}${Config.prefixUrl}/session-oauth/`,
            scopes: ["user-info", "user_msisdn", "ftth_info"],
        });
    }
}
